import { FarmSubdivision } from '../../types/apiModels'
import { apiClient } from '../ruutsApi/client'
import endpoints from '../ruutsApi/endpoints'
import { unwrapCollection } from '../ruutsApi/normalize'

// The v1 list answers an empty payload for an id that no longer resolves, so the row is optional.
export default async function getFarmSubdivisionById({
  id,
  farmId,
  signal,
}: {
  id: string
  farmId: string
  signal?: AbortSignal
}): Promise<FarmSubdivision | undefined> {
  const response = await apiClient.get(endpoints.farmSubdivisions, {
    params: { id, farmId },
    signal,
  })
  return unwrapCollection<FarmSubdivision>(response)[0]
}
